import { Reducer } from 'redux'
import { Resort } from '../report/types'
import { GetResortTypes, ResortState } from './types'

const INITIAL_STATE: ResortState = {
  data: {} as Resort,
  loading: false,
  error: false,
  errorStack: undefined
}

const reducer: Reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GetResortTypes.GET_RESORT_REQUEST:
      return { ...state, loading: true, error: false, errorStack: undefined }
    case GetResortTypes.GET_RESORT_SUCCESS:
      return {
        ...state,
        data: action.payload,
        loading: false,
        error: false,
        errorStack: undefined
      }
    case GetResortTypes.GET_RESORT_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        errorStack: action.payload.errorStack
      }
    default:
      return state
  }
}

export default reducer
